<script setup lang="ts">
import { cases, sources } from '../content'
import { politicians } from '../content/politicians'
import AnaClaraHighlight from '../components/AnaClaraHighlight.vue'
import NetworkHighlight from '../components/NetworkHighlight.vue'
import PhotoCredit from '../components/PhotoCredit.vue'
import { publicPhotos } from '../content/public-photos'
const portrait = (slug: string) => slug === 'jair-bolsonaro' ? 'jair-pr' : 'flavio-oficial'
</script>

<template>
  <div class="politician-index">
    <header class="politician-index__hero">
      <div class="wrap">
        <div class="politician-index__kicker"><span>ARQUIVO PÚBLICO // BRASIL</span><span>{{ politicians.length.toString().padStart(2, '0') }} PERFIL ATIVO</span></div>
        <h1>Quem pede seu voto<br><em>deixa rastros.</em></h1>
        <p>Escolha um nome. Abra o histórico. Compare discurso, documento, dinheiro, relações e decisões sem depender da memória da campanha.</p>
      </div>
    </header>

    <AnaClaraHighlight />
    <NetworkHighlight />

    <main class="wrap politician-index__body">
      <div class="politician-index__heading">
        <div><span class="eyebrow">Políticos rastreados</span><h2>Arquivos abertos</h2></div>
      </div>

      <div class="politician-grid">
        <div v-for="politician in politicians" :key="politician.slug" class="politician-entry">
        <RouterLink :to="politician.route" class="politician-card">
          <div class="politician-card__portrait"><picture><source :srcset="`${publicPhotos[portrait(politician.slug)].path}.avif`" type="image/avif"><img :src="`${publicPhotos[portrait(politician.slug)].path}.webp`" :width="publicPhotos[portrait(politician.slug)].width" :height="publicPhotos[portrait(politician.slug)].height" :alt="publicPhotos[portrait(politician.slug)].alt" loading="lazy" decoding="async"></picture></div>
          <div class="politician-card__content">
            <span class="politician-card__status">● arquivo ativo</span>
            <p>{{ politician.office }} · {{ politician.party }}–{{ politician.state }}</p>
            <h3>{{ politician.name }}</h3>
            <p>{{ politician.summary }}</p>
            <dl><div><dt>Dossiês</dt><dd>{{ cases.filter(record => record.peopleIds.includes(politician.slug)).length }}</dd></div><div><dt>Fontes</dt><dd>{{ new Set(cases.filter(record => record.peopleIds.includes(politician.slug)).flatMap(record => record.sources)).size }}</dd></div></dl>
            <strong>Abrir rastreio <span aria-hidden="true">→</span></strong>
          </div>
        </RouterLink>
        <PhotoCredit :image="portrait(politician.slug)" />
        </div>
      </div>

    </main>
  </div>
</template>
